import { devtools } from 'zustand/middleware';
import { create } from 'store/create';
import { ValuationsStore } from './types';

const useValuationsStore = create<ValuationsStore>()(
  devtools(
    set => ({
      currentCapTable: null,
      currentCapTableVersions: null,
      currentValuation: null,
      refreshAllMarketDataHandler: null,
      setCurrentCapTable: currentCapTable => set(() => ({ currentCapTable })),
      setCurrentCapTableVersions: currentCapTableVersions => set(() => ({ currentCapTableVersions })),
      setCurrentValuation: currentValuation => set(() => ({ currentValuation })),
      setRefreshAllMarketDataHandler: refreshAllMarketDataHandler => set(() => ({ refreshAllMarketDataHandler })),
    }),
    {
      name: 'ValuationsStore',
    }
  )
);

export default useValuationsStore;
